import React from "react";
import { Link } from "react-router-dom";
import { User, Rocket as RocketIcon } from "lucide-react";
import FavHeart from "./FavHeart";
import ShareButton from "./ShareButton";

function ageBadge(a) {
  if (a?.status?.name === "Deceased") return "DECEASED";
  if (a?.in_space) return "IN SPACE";
  if (a?.status?.name) return a.status.name.toUpperCase();
  return "UNKNOWN";
}

export default function AstronautCard({ astronaut }) {
  const { id, name, agency, profile_image, nationality, country_code, flights_count, spacewalks_count } = astronaut;
  return (
    <Link to={`/roster/astronaut/${id}`} data-testid={`astronaut-card-${id}`}
      className="sat-surface sat-brackets group block relative transition-all hover:sat-box-glow">
      <div className="h-44 bg-black overflow-hidden relative">
        {profile_image ? (
          <img src={profile_image} alt={name} loading="lazy" className="w-full h-full object-cover opacity-85 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center"><User size={40} className="text-[color:var(--sat-border-bright)]" /></div>
        )}
        <div className="absolute top-2 left-2 border border-[color:var(--sat-cyan)] px-2 py-1 sat-label sat-cyan bg-black/60">
          {ageBadge(astronaut)}
        </div>
      </div>
      <div className="p-4 flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <span className="sat-label sat-cyan">{country_code || "—"}</span>
          <div className="flex items-center gap-1.5">
            <ShareButton url={`${window.location.origin}/roster/astronaut/${id}`} title={name} size={11} testid={`astronaut-share-${id}`} />
            <FavHeart kind="astronaut" ref_id={id} title={name} image={profile_image} size={12} />
          </div>
        </div>
        <h3 className="font-display font-bold text-lg leading-tight group-hover:text-[color:var(--sat-cyan)] transition-colors line-clamp-1">
          {name}
        </h3>
        <p className="text-xs text-[color:var(--sat-text-dim)] font-mono truncate">{agency?.name || "—"}</p>
        <div className="flex gap-4 mt-1 sat-label">
          <span><RocketIcon size={10} className="inline mr-1" />{flights_count ?? 0} FLIGHTS</span>
          <span>{spacewalks_count ?? 0} EVAS</span>
        </div>
      </div>
    </Link>
  );
}
